import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import CustomImage from "../../Assets/Images/img2.png";

const CustomStyle = ({ orderImage }) => {
  let navigate = useNavigate();
  const ImageRef = useRef();
  const ImageRef1 = useRef();
  const ImageRef2 = useRef();
  const ImageRef3 = useRef();
  const ImageRef4 = useRef();

  useEffect(() => {
    ImageRef.current.src = orderImage[0];
    ImageRef3.current.src = orderImage[0];
    ImageRef1.current.src = orderImage[1] ?? orderImage[0];
    ImageRef2.current.src = orderImage[2] ?? orderImage[0];
    ImageRef4.current.src = orderImage[1] ?? orderImage[0];
  }, [orderImage]);
  return (
    <div className="clearfix">
      <div className="itemImg">
        <div className="productImg_div">
          <p className="product_para">
            <span onClick={() => navigate(-1)}>
              {/* <Link to={ backarrow ? "/tailoring/malestyle" : "/tailoring/femalestyle"}> */}
              <button className="male_backarrow">
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              {/* </Link> */}
            </span>

            <span>Custom Order</span>
          </p>
          <img alt="img" className="product_img" ref={ImageRef} src={orderImage} style={{objectFit: 'cover'}} />
        </div>
        <div className="sProduct">
          <img alt="img" ref={ImageRef1} src={orderImage} />
          <img alt="img" ref={ImageRef2} src={orderImage} style={{height: '80px'}} />
          <img alt="img" ref={ImageRef3} src={orderImage} style={{height: '80px'}} />
          <img alt="img" ref={ImageRef4} src={orderImage} />
        </div>
      </div>
    </div>
  );
};

export default CustomStyle;
